import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, loggedUser, loginSuccess } from "../../../redux/authSlice";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user: data, token, loading, error } = useSelector((state) => state.auth);
  const [user, setUser] = useState({ identifier: "", password: "" });

  const handleSubmit = (e) => {

    e.preventDefault();
    dispatch(loginUser(user)).then((res) => {
      if (res.payload?.accessToken) {
        localStorage.setItem("token", res.payload.accessToken);  // ✅ Store token properly
        dispatch(loggedUser(res.payload.accessToken)).then((res) => {
          if (res.payload) {
            localStorage.setItem("user", JSON.stringify(res.payload));  // ✅ Store user properly
            dispatch(loginSuccess({ user: { name: res.payload.name, role: res.payload.role, role: res.payload.role }, token: res.payload.accessToken }));
            const role = localStorage.setItem("role", res.payload.role);
            if (process.env.NODE_ENV === "development") {
              console.log("role", role);
            }
          }
        }).catch((error) => toast.error(error));
        toast.success(res.payload.message);
        navigate("/", {
          replace: true
        });

      } else if (res.payload?.error === "Please verify your email first") {
        setShowResend(true); // Show the resend verification option
        toast.error("Please verify your email first.");
      } else {
        toast.error(res.payload.error);
      }
    }).catch((error) => toast.error(error));
  };

  return (
    <section>

      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Row className="p-4 shadow-lg rounded-4" style={{ width: '100%', maxWidth: '400px' }}>

          <Col xxl={12}>
            <h2 className="mb-3 text-center">Login</h2>
            {/* {error && <Alert variant="danger">{error}</Alert>} */}
            {error && typeof error === "string" && <Alert variant="danger">{error}</Alert>}
            {error && typeof error === "object" && <Alert variant="danger">{error.message}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter email"
                  value={user.identifier}
                  onChange={(e) => setUser({ ...user, identifier: e.target.value })}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={user.password}
                  onChange={(e) => setUser({ ...user, password: e.target.value })}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </Form>
          </Col>

          <Col xxl={12}>
            <div className="mt-3 text-center">
              <Link to="/forgot-password" className="mb-2 d-block">Forgot Password?</Link>
              <span>Don't have an account? </span>
              <Link to="/signup">Sign Up</Link>
            </div>
          </Col>
        </Row>
      </Container>

    </section>
  );
};

export default Login;
